import { useContext } from 'react';
import CardHelpLink from './CardHelpLink';
import RightPartContent from './RightPartContent';
import UserGoBack from '../user/UserGoBack';
import dataApplicationsContext from '../../context/dataApplicationsContext';

const IndexLinks = ({ goBackLinks, links }) => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const isSmallDevise = windowWidth < 900;

  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo=' '
      />
      <div className="help-content-container">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            {links.map((link, index) => {
              return (
                <CardHelpLink title={link.title} link={link.link} titleClass="fz-16 fw-500 text-underline cursor-pointer" key={'link-' + index}/>
              )
            })}
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default IndexLinks